import { c as _c } from "react/compiler-runtime";
import type { ButtonProps as ChakraCloseButtonProps } from '@chakra-ui/react';
import { IconButton as ChakraIconButton } from '@chakra-ui/react';
import { forwardRef } from 'react';
import { LuX } from 'react-icons/lu';
export interface CloseButtonProps extends ChakraCloseButtonProps {}
export const CloseButton = forwardRef<HTMLButtonElement, CloseButtonProps>(function CloseButton(props, ref) {
  const $ = _c(6);
  let t0;
  if ($[0] !== props.children) {
    t0 = props.children ?? <LuX />;
    $[0] = props.children;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props || $[3] !== ref || $[4] !== t0) {
    t1 = <ChakraIconButton variant="ghost" aria-label="Close" ref={ref} {...props}>{t0}</ChakraIconButton>;
    $[2] = props;
    $[3] = ref;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
});